import { useLocale, useT } from '../i18n';
import { useApiData } from '../api/useApiData';
import { contentApi } from '../api/content';
import AsyncSection from '../components/shared/AsyncSection';

export default function NationalTransformation() {
  const locale = useLocale();
  const t = useT();
  const capsState = useApiData(() => contentApi.nationalCapabilities(locale), [locale]);
  const levelsState = useApiData(() => contentApi.nationalMaturityModel(locale), [locale]);

  return (
    <section className="section" style={{ paddingTop: 160 }}>
      <div className="container">
        <div className="section-head reveal is-visible">
          <span className="eyebrow">{t('nav.national')}</span>
          <h1>National Transformation</h1>
          <p className="body-lg">A distinct tone and pacing from the enterprise Solutions section — this is not a sales pitch, it is a governance conversation.</p>
        </div>

        <h2>Capabilities</h2>
        <AsyncSection
          state={capsState}
          render={(caps) => (
            <div className="card-grid">
              {caps.map((c: any) => (
                <div className="card reveal is-visible" key={c.code}>
                  <span className="badge badge-core">{c.code}</span>
                  <h3 style={{ marginTop: 12 }}>{c.name}</h3>
                  <p className="body-sm">{c.description}</p>
                </div>
              ))}
            </div>
          )}
        />

        <h2 style={{ marginTop: 48 }}>Maturity model</h2>
        <AsyncSection
          state={levelsState}
          render={(levels) => (
            <div className="stepper reveal is-visible">
              {levels.map((label, i) => (
                <div className="step-item" key={label}>
                  <div className="num">{String(i + 1).padStart(2, '0')}</div>
                  <h3>{label}</h3>
                </div>
              ))}
            </div>
          )}
        />
      </div>
    </section>
  );
}
